import { Component, Input, OnInit } from '@angular/core';
import { ChartBaseDirective } from '@client/app/modules/charts/directives/chart-base.directive';
import { DEFAULT_CHART_SETTINGS } from '@client/app/modules/charts/constants/Chart.constant';
import { LegendCursorService } from '@client/app/modules/charts/services/LegendCursor.service';

@Component({
    selector: 'mon-chart-horizontal-bar',
    templateUrl: './horizontal-bar.component.html',
    standalone: true,
    imports: [
        ChartBaseDirective,
    ],
})
export class HorizontalBarComponent implements OnInit {
    @Input() labels: any[] = [];
    @Input() data: any[] = [];
    @Input() options?: any | undefined;
    @Input() colors: any[] = [];
    @Input() height = DEFAULT_CHART_SETTINGS.CHART.HEIGHT;
    @Input() override?: any[] | undefined;
    @Input() series: any[] = [];

    constructor (private legendCursorService: LegendCursorService) {}

    ngOnInit (): void {
        this.legendCursorService.setHoverState(this.options);
    }
}
